import Login from './views/Login.vue';

export const PublicRoutes = [
	{
		path: '/login',
		component: Login,
		name: 'login',
		meta: {
			auth: false
		}
	}
];